import React from 'react';

const TSWLogin = () => {
    return <h1>Login</h1>;
    };

export default TSWLogin;